import { LANGUAGES, useSiteLang } from "../lib/siteLang";

export const Languages = () => {
  const { t } = useSiteLang();

  return (
    <section className="py-16 md:py-20 bg-[#0C1A2E] border-y border-white/10" data-testid="languages-section">
      <div className="max-w-6xl mx-auto px-5 md:px-10 text-center">
        <p className="section-label mb-4">{t.langsLabel}</p>
        <h2 className="text-2xl md:text-4xl text-white mb-9" style={{ textWrap: "balance" }}>{t.langsTitle}</h2>
        <ul className="flex flex-wrap justify-center gap-3" aria-label={t.langsLabel}>
          {LANGUAGES.map((name) => (
            <li key={name} className="rounded-full border border-white/20 bg-white/[0.06] px-4 py-2 text-white text-sm md:text-base">
              {name}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
